import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { Device } from '../../models/device.model';
import { MdmLinkPipe } from '../pipes/mdm-link.pipe';

@Component({
  selector: 'era-device-action-bar-ui',
  templateUrl: './device-action-bar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, FaIconComponent, MdmLinkPipe, RouterLink, FaIconComponent, MdmLinkPipe],
})
export class DeviceActionBarComponent {
  public readonly allowAssign = input(false);
  public readonly allowSpare = input(false);
  public readonly allowUnassign = input(false);
  public readonly allowUnavailable = input(false);

  public readonly device = input.required<Device>();
  public readonly notesEnabled = input(false);
  public readonly assignmentHistoryEnabled = input(false);

  public readonly openNotesModalEvent = output<object>();
  public readonly openAssignmentHistoryModalEvent = output<object>();

  openNotes() {
    this.openNotesModalEvent.emit({});
  }

  openAssignmentHistory() {
    this.openAssignmentHistoryModalEvent.emit({});
  }
}
